<template>
  <v-dialog @input="toggleModal()"
            max-width="1000px"
            scrollable
            :value="value">
    <v-card>
      <v-toolbar color="abadPrimary"
                 dark
                 dense
                 flat>
        <v-toolbar-title>
          Detalles
        </v-toolbar-title>

        <v-spacer/>

        <v-icon @click="toggleModal()">
          mdi-close
        </v-icon>

        <template v-slot:extension>
          <v-tabs v-model="tabs"
                  centered
                  slider-color="yellow">
            <v-tab href="#tab-detalles">
              Detalles
            </v-tab>

            <v-tab href="#tab-fotos">
              Fotos
            </v-tab>

            <v-tab href="#tab-asesor">
              Asesor
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-card-text>
        <v-tabs-items v-model="tabs">
          <v-tab-item value="tab-detalles">
            <v-card flat>
              <v-card-text>
                <v-row>
                  <v-col cols="12" v-if="details.valorVendido">
                    <v-alert type="error"
                             :value="true">
                      Vendido por {{details.valorVendido}}
                    </v-alert>
                  </v-col>

                  <v-col class="font-weight-bold text-h6 my-4"
                         cols="12">
                    Información prioritaria
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.codigo">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Código
                    </div>

                    <div>
                      {{details.codigo}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.propietario">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Propietario
                    </div>

                    <div>
                      {{details.propietario}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="telefonos">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Propietario Teléfonos
                    </div>

                    <div>
                      <a :href="`tel:${phone}`"
                         :key="phone"
                         style="text-decoration: none"
                         v-for="phone in telefonos">
                        <v-chip class="ma-1"
                                color="abadPrimary"
                                outlined
                                style="cursor: pointer;">
                          <v-icon left>
                            mdi-phone
                          </v-icon>
                          {{phone}}
                        </v-chip>
                      </a>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.zona">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Zona
                    </div>

                    <div>
                      {{details.zona}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.sector">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Sector
                    </div>

                    <div>
                      {{details.sector}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.barrio">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Barrio
                    </div>

                    <div>
                      {{details.barrio}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.direccion">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Dirección
                    </div>

                    <div>
                      {{details.direccion}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.estado">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Estado
                    </div>

                    <div>
                      {{details.estado}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.frecuenciaPredial">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Frecuencia Predial
                    </div>

                    <div>
                      {{details.frecuenciaPredial}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.llaves">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Llaves
                    </div>

                    <div>
                      {{details.llaves}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.numApto">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Número de apartamento
                    </div>

                    <div>
                      {{details.numApto}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.proposito">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Propósito
                    </div>

                    <div>
                      {{details.proposito}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.tipoPropiedad">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Tipo de Propiedad
                    </div>

                    <div>
                      {{details.tipoPropiedad}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.urbanizacion">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Urbanización
                    </div>

                    <div>
                      {{details.urbanizacion}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.valorAdmin">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Valor Administración
                    </div>

                    <div>
                      {{details.valorAdmin}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.valorVenta">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Valor Venta
                    </div>

                    <div>
                      {{details.valorVenta}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.valorArriendo">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Valor Arriendo
                    </div>

                    <div>
                      {{details.valorArriendo}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.valorPredial">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Valor Predial
                    </div>

                    <div>
                      {{details.valorPredial}}
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <div class="text-caption font-weight-bold abadPrimary--text"
                         v-if="details.comentarios">
                      Comentarios
                    </div>

                    <div>
                      {{details.comentarios}}
                    </div>
                  </v-col>

                  <v-col cols="12" v-if="details.areasComunesArr">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Áreas comunes
                    </div>

                    <div>
                      <v-chip color="abadPrimary"
                              class="ma-2"
                              outlined
                              v-for="item in details.areasComunesArr"
                              :key="item">
                        {{item}}
                      </v-chip>
                    </div>
                  </v-col>

                  <v-col class="font-weight-bold text-h6 my-4"
                         cols="12">
                    Información de la propiedad
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.alcobaServicio">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Alcoba de servicio
                    </div>

                    <div>
                      {{details.alcobaServicio}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.alcobas">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Alcobas
                    </div>

                    <div>
                      {{details.alcobas}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.anoConstruido">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Año construido
                    </div>

                    <div>
                      {{details.anoConstruido}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.areaConstruida">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Área construida
                    </div>

                    <div>
                      {{details.areaConstruida}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.areaLote">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Área lote
                    </div>

                    <div>
                      {{details.areaLote}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.areaTerraza">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Área Terraza
                    </div>

                    <div>
                      {{details.areaTerraza}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.ascensor">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Ascensor
                    </div>

                    <div>
                      {{details.ascensor}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.avaluoCatastral">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Avaluo catastral
                    </div>

                    <div>
                      {{details.avaluoCatastral}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.balcon">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Balcón
                    </div>

                    <div>
                      {{details.balcon}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.banoServicio">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Baño de servicio
                    </div>

                    <div>
                      {{details.banoServicio}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.banosAlcoba">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Baños de alcobas
                    </div>

                    <div>
                      {{details.banosAlcoba}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.banosSocial">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Baño social
                    </div>

                    <div>
                      {{details.banosSocial}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.biblioteca">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Biblioteca
                    </div>

                    <div>
                      {{details.biblioteca}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.cocina">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Cocina
                    </div>

                    <div>
                      {{details.cocina}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.comedor">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Comedor
                    </div>

                    <div>
                      {{details.comedor}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.cuartoUtil">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Cuarto Útil
                    </div>

                    <div>
                      {{details.cuartoUtil}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.destacado">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Destacado
                    </div>

                    <div>
                      {{details.destacado}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.duplex">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Duplex
                    </div>

                    <div>
                      {{details.duplex}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.espacioUrbano">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Espacio Urbano
                    </div>

                    <div>
                      {{details.espacioUrbano}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.estar">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Estar
                    </div>

                    <div>
                      {{details.estar}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.estrato">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Estrato
                    </div>

                    <div>
                      {{details.estrato}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.fechaCreacion">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Fecha de Creación
                    </div>

                    <div>
                      {{details.fechaCreacion}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.fechaModificacion">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Fecha de Modificación
                    </div>

                    <div>
                      {{details.fechaModificacion}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.fechaVenta">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Fecha de Venta
                    </div>

                    <div>
                      {{details.fechaVenta}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.garajes">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Garajes
                    </div>

                    <div>
                      {{details.garajes}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.gas">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Gas
                    </div>

                    <div>
                      {{details.gas}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.materialPisos">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Material Pisos
                    </div>

                    <div>
                      {{details.materialPisos}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.matriculaInmobiliaria">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Matricula Inmobiliaria
                    </div>

                    <div>
                      {{details.matriculaInmobiliaria}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.patioRopas">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Patio de Ropas
                    </div>

                    <div>
                      {{details.patioRopas}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.penthouse">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Penthouse
                    </div>

                    <div>
                      {{details.penthouse}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.permuta">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Permuta
                    </div>

                    <div>
                      {{details.permuta}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.porteria">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Portería
                    </div>

                    <div>
                      {{details.porteria}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.salon">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Salón
                    </div>

                    <div>
                      {{details.salon}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.unidadCerrada">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Unidad Cerrada
                    </div>

                    <div>
                      {{details.unidadCerrada}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.video">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Video
                    </div>

                    <div>
                      {{details.video}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="details.zonaProp">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Zona Prop
                    </div>

                    <div>
                      {{details.zonaProp}}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-fotos">
            <v-card flat>
              <v-card-text>
                <v-row>
                  <v-col cols="12"
                         sm="6"
                         md="4"
                         :key="item"
                         v-for="item in details.thumbnails">
                    <v-img :src="item"></v-img>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-asesor">
            <v-card flat>
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="text-center">
                    <v-avatar size="150">
                      <v-img :src="asesor.foto"/>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Nombres
                    </div>

                    <div>
                      {{asesor.nombres}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Email
                    </div>

                    <div>
                      {{asesor.email}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Celular
                    </div>

                    <div>
                      {{asesor.celular}}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <div class="text-caption font-weight-bold abadPrimary--text">
                      Fijo
                    </div>

                    <div>
                      {{asesor.fijo}}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <a :href="`https://www.abadfaciolince.com/propiedad/?codigo=${details.codigo}`"
           style="text-decoration: none"
           target="_blank">
          <v-btn color="abadPrimary" outlined>
            <v-icon left>
              mdi-web
            </v-icon>

            Visitar en web
          </v-btn>
        </a>

        <v-spacer/>

        <v-btn @click="toggleModal()"
               color="abadPrimary"
               text>
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import realEstateService from '@/services/realEstateService.js'
export default {
  computed: {
    asesor () {
      if (!this.details || !this.details.asesor) return {}
      return this.details.asesor
    },
    telefonos () {
      if (!this.details || !this.details.propietarioTelefonos) return []
      const telefonos = this.details.propietarioTelefonos.split(' - ')
      return telefonos.filter(item => item !== '')
    }
  },
  data: () => ({
    details: {},
    tabs: 'tab-1'
  }),
  methods: {
    toggleModal () {
      this.$emit('input', false)
    }
  },
  props: ['selected', 'value'],
  watch: {
    async selected (value) {
      if (value) {
        this.details = await realEstateService.getPropertyDetails(value)
      }
    }
  }
}
</script>
